import { inject, Injectable } from '@angular/core';
import { CapacitorService } from '@libs/shared/common';
import { AppTrackingStatusResponse, AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';

@Injectable({
  providedIn: 'root',
})
export class AppleAppTrackingService {
  private readonly capacitorService: CapacitorService = inject(CapacitorService);

  public async requestAppleAppTracking(): Promise<boolean> {
    if (!this.capacitorService.isRunningOnIOS()) {
      return false;
    }

    // if this returns denied even before the user has clicked anything the device is set to disabled for all apps
    // can be adjusted in the settings
    const response: AppTrackingStatusResponse = await AppTrackingTransparency.getStatus();

    if (response.status !== 'notDetermined') {
      return response.status === 'authorized';
    }

    // https://lekkerland.atlassian.net/browse/IPS-3770
    // Apple requires integration of ATT, but the real consent management is done via ConsentManagerService
    const permission: AppTrackingStatusResponse = await AppTrackingTransparency.requestPermission();

    return permission.status === 'authorized';
  }
}
